class EventEmitterService {
  constructor() {
    this.events = {};
    this.eventTypes = {
      SOCKETS_OPEN: 'sockets:open',
      SOCKETS_RECONNECT: 'sockets:reconnect',
      SOCKETS_MESSAGE: 'sockets:message',
      MOBILE_CALL_TICKET: 'mobile:call-ticket',
      AUTOCALL_CALL: 'autocall:call',
      STATUS_CHANGE: 'status:change',
      TIME_TICK: 'time:tick',
      CLEAR_DEVICE: 'device:clear',
      WORKSPACE_RELOAD: 'workspace:reload'
    }
  }

  subscribe(eventName, fn) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }

    this.events[eventName].push(fn);

    return () => {
      this.events[eventName] = this.events[eventName].filter(eventFn => fn !== eventFn);
    }
  }

  emit(eventName, data) {
    const event = this.events[eventName];
    if (event) {
      event.forEach(fn => {
        fn.call(null, data);
      });
    }
  }
}

export default EventEmitterService
